const config = {
  env: "local",
  apiUrl: "https://api.astrovedvaani.com/api/",
  //  apiUrl: "http://192.168.0.11:5000/api/",
};

export default config;
